import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import Header from "./Header";
import Footer from "./Footer";
import styles from "./Landing.module.css";

const Layout = ({ children, onNavClick, activeSection }) => {
  return (
    <div className={styles.rootContainer}>
      <Header onNavClick={onNavClick} activeSection={activeSection} />
      <main className={styles.mainContent}>
        {children}
      </main>
      <Footer onNavClick={onNavClick} />

      {/* Floating Call Now CTA */}
      <a
        href="tel:+919024989935"
        className={styles.floatingCallBtn}
        aria-label="Call ReformMe Healthcare Clinic Now"
      >
        <FontAwesomeIcon icon={faPhoneAlt} />
        <span>Call Now</span>
      </a>
    </div>
  );
};

export default Layout;
